/* QM Build fix: SS Stats count-up sections fail when their inline script registers
   DOMContentLoaded after the event has already fired, leaving counters frozen at
   their start value (e.g. "0%", "1 M"). This patch re-runs the animation for any
   un-animated stats counters, safely and idempotently. Additive file - no existing
   file modified. Loaded from layout/theme.liquid on the QM Build theme only. */
(function () {
  function animate(el) {
    var from = parseInt(String(el.dataset.from || '0').replace(/,/g, ''), 10) || 0;
    var to = parseInt(String(el.dataset.to || '0').replace(/,/g, ''), 10) || 0;
    if (el.dataset.qmAnimated === '1' || to === 0) return;
    var current = from;
    var speed = 2; /* seconds, matches section default */
    function fmt(n) { return n.toLocaleString('en-US'); }
    function step() {
      current += (to - from) / (speed * 60);
      if ((to > from && current >= to) || (to < from && current <= to)) {
        el.textContent = fmt(Math.round(to));
        return;
      }
      el.textContent = fmt(Math.round(current));
      requestAnimationFrame(step);
    }
    el.dataset.qmAnimated = '1';
    step();
  }

  function init() {
    var els = document.querySelectorAll('p[data-from][data-to]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(animate);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) {
      /* Only adopt counters still frozen at their start value */
      var from = String(el.dataset.from || '').replace(/,/g, '');
      var now = String(el.textContent || '').trim().replace(/,/g, '');
      if (now === from || now === '' ) {
        observer.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 400); });
  } else {
    setTimeout(init, 400);
  }
})();
